/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Ai_PrivateInputs */



/**
* | output |
* | --- |
* | "Private model hosting" |
*
* @param {Compare_Ai_PrivateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_ai_private = /** @type {((inputs?: Compare_Ai_PrivateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Ai_PrivateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Privates Modell-Hosting")
	return /** @type {LocalizedString} */ ("Private model hosting")
});